import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 3.375C3.75 2.33979 4.58979 1.5 5.625 1.5H10.5C13.0859 1.5 15.5658 2.52723 17.3943 4.35571C19.2228 6.18419 20.25 8.66414 20.25 11.25V20.625C20.25 21.6602 19.4102 22.5 18.375 22.5H5.625C4.58979 22.5 3.75 21.6602 3.75 20.625V3.375ZM18.75 11.625C18.75 10.9288 18.4734 10.2611 17.9812 9.76884C17.4889 9.27656 16.8212 9 16.125 9H14.625C14.1277 9 13.6508 8.80246 13.2992 8.45083C12.9475 8.09919 12.75 7.62228 12.75 7.125V5.625C12.75 4.92881 12.4734 4.26113 11.9812 3.76884C11.4889 3.27656 10.8212 3 10.125 3H5.625C5.41821 3 5.25 3.16821 5.25 3.375V20.625C5.25 20.8318 5.41821 21 5.625 21H18.375C18.5818 21 18.75 20.8318 18.75 20.625V11.625ZM13.7575 3.67034C14.0779 4.2658 14.25 4.93653 14.25 5.625V7.125C14.25 7.22446 14.2895 7.31984 14.3598 7.39016C14.4302 7.46049 14.5255 7.5 14.625 7.5H16.125C16.8135 7.5 17.4842 7.67212 18.0797 7.99251C17.6702 7.03985 17.081 6.16379 16.3336 5.41637C15.5862 4.66895 14.7102 4.07976 13.7575 3.67034ZM12 10.5C12.4142 10.5 12.75 10.8358 12.75 11.25V13.5H15C15.4142 13.5 15.75 13.8358 15.75 14.25C15.75 14.6642 15.4142 15 15 15H12.75V17.25C12.75 17.6642 12.4142 18 12 18C11.5858 18 11.25 17.6642 11.25 17.25V15H9C8.58579 15 8.25 14.6642 8.25 14.25C8.25 13.8358 8.58579 13.5 9 13.5H11.25V11.25C11.25 10.8358 11.5858 10.5 12 10.5Z"
        fill={colorValue}
      />
    </svg>
  );
};
